module.exports = __webpack_public_path__ + "media/images/hbt_boards-c1abbdb0650e4f5a944a6faba091c0a2.png";